import { useHistory, useLocation } from "react-router-dom";

import ImgWrapper from "./ImgWrapper";
import Notifications from "views/notifications/Notifications";
import React from "react";
import Spacer from "./Spacer";
import UserOptions from "views/userAccount/UserOptions";
import chatIcon from "assets/icons/chatIcon.svg";
import { connect } from "react-redux";
import menuIcon from "assets/icons/sidebar_menu.svg";
import { setSidebarCollapsed } from "api";
import styled from "styled-components";
import { useState } from "react";

const Wrapper = styled.nav`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 7.2rem;
  padding: 0 24px;
  border-bottom: 1px solid #e5e7eb;
  background-color: var(--white);
  position: sticky;
  top: 0;
  z-index: 10;

  .readCover {
    position: relative;
    z-index: 100;
    background: white;
    top: 20rem;
    left: 59%;
  }

  .chatSupport {
    padding: 1.2rem;
    border-radius: 4px;
    transition: all 0.2s ease-out;
    gap: 0.6rem;

    .icon {
      height: 20px;
    }

    .text {
      color: var(--grey_6);
    }

    &:hover {
      background-color: var(--background);
    }
  }

  @media screen and (max-width: 768px) {
    .chatSupport .text {
      display: none;
    }
  }
`;

const User = styled.div`
  width: max-content;
  position: relative;

  .userIcon,
  .downIcon {
    height: 1.6rem;
  }

  .menu {
    background-color: var(--white);
    width: 16rem;
    border-radius: 0.4rem;
    position: absolute;
    top: 2.4rem;
    right: 0;
    box-shadow: 0px 0px 10px var(--background);
    z-index: 10;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-out;

    &.show {
      top: 4.8rem;
      opacity: 1;
      pointer-events: all;
    }

    .item {
      padding: 1.6rem;
      width: 100%;
      text-align: left;

      &:hover {
        background-color: var(--background);
      }
    }
  }
`;

const Avatar = styled(ImgWrapper)`
  .initials {
    color: #ffffff;
    line-height: 18px;
  }
`;

const Back = styled.button`
  height: 100%;
  padding: 1.2rem 0;

  .icon {
    height: 36px;
    padding: 6px;
    background-color: var(--off_white);
    border-radius: 50%;
  }
`;

const OpenSidebar = styled(Back)`
  display: none;
  left: 24px;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

const Navbar = ({ user, pageTitle }) => {
  const router = useHistory();
  const [showUserOptions, setShowUserOptions] = useState(false);
  const { pathname } = useLocation();

  const openChatWidget = () => {
    try {
      window.Tawk_API.maximize();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Wrapper>
      <div className="flexRow justifyEnd alignCenter">
        {pathname.split("/").length > 3 && !pathname.includes("analytics") && (
          <div className="flexRow lg">
            <Back onClick={() => router.goBack()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="var(--grey_7)"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </Back>
            <Spacer x={2.4} />
          </div>
        )}
        <h5 className="lg pageTitle">{pageTitle}</h5>
        <OpenSidebar
          className="openSidebar mb"
          // onClick={() => {
          //   setSidebarOpen(true);
          // }}
          onClick={() =>
            document.querySelector(".sidebar").classList.add("open")
          }
        >
          <img
            src={menuIcon}
            alt="menu"
            className="icon"
            title="Open sidebar"
          />
        </OpenSidebar>
      </div>
      <div className="flexRow justifyEnd alignCenter">
        <button
          className="flexRow alignCenter chatSupport support-tour"
          title="Chat support"
          onClick={openChatWidget}
        >
          <img className="icon" src={chatIcon} alt="chat" />
          <span className="text">Get help</span>
        </button>
        <Spacer x={3.6} xMobile={1.2} />
        <Notifications />
        <Spacer x={3.6} />
        <User>
          <Avatar
            as="button"
            bg="var(--primary)"
            size={4}
            onClick={() => setShowUserOptions(true)}
            id="avi-target"
          >
            {user?.image ? (
              <img src={`${user.image}`} alt="avatar" />
            ) : (
              <h5 className="initials textCenter textUppercase">{`${user?.full_name
                ?.split(" ")[0]
                .charAt(0)}${user?.full_name?.split(" ")[1].charAt(0)}`}</h5>
            )}
          </Avatar>
          {showUserOptions && (
            <UserOptions setShowUserOptions={setShowUserOptions} />
          )}
        </User>
      </div>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    pageTitle: state.page_title,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSidebarCollapsed: (status) => dispatch(setSidebarCollapsed(status)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
